import { configureStore } from '@reduxjs/toolkit';
import assetSlice from '../features/asset/AssetDataSlice';
import rodPumpWellStatusReducer from '../features/asset-status/AssetStatusSlice';
import uiButtonToolbarReducer from '../features/navigation/UIButtonToolbarSlice';
import assetGroupReducer from '../features/navigation/AssetGroupsSlice';
import cardDateSlice from '../features/rod-lift-analysis/CardDateSlice';
import cardCoordinatesSlice from '../features/rod-lift-analysis/CardCoordinatesSlice';
import analysisSlice from '../features/rod-lift-analysis/AnalysisSlice';
import notificationSlice from '../features/navigation/NotificationsSlice';
import notificationsTypesSlice from '../features/navigation/NotificationTypesSlice';
import tableViewSlice from '../features/group-status/TableViewSlice';
import groupStatusSlice from '../features/group-status/GroupStatusSlice';
import groupStatusWidgetSlice from '../features/group-status/GroupStatusWidgets/GroupStatusWidgetSlice';
import espAnalysisSlice from '../features/esp-analysis/ESPAnalysisSlice';
import espCardCoordinatesSlice from '../features/esp-analysis/ESPCardCoordinatesSlice';
import espWellTestSlice from '../features/esp-analysis/WellTestSlice';
import glAnalysisSlice from '../features/gl-analysis/GLAnalysisSlice';
import gLAnalysisSurveyDateSlice from '../features/gl-analysis/GLAnalysisSurveyDateSlice';
import glAnalysisWellTestSlice from '../features/gl-analysis/GLAnalysisWellTestSlice';
import notificationFilterReducer from '../features/navigation/NotificationFilterSlice';
import viewOptionsReducer from '../features/common/ViewOptions/ViewOptionsSlice';
import AssetAnalysisSlice from '../features/asset-analysis/AssetAnalysisSlice';
import signInDefaultViewSlice from '../onboarding/default-view/SignInDefaultViewSlice';
import glAnalysisSurveyCurveCoordinatesSlice from '../features/gl-analysis/GLAnalysisSurveyCurveCoordinatesSlice';
import glAnalysisCurveCoordinatesSlice from '../features/gl-analysis/GLAnalysisCurveCoordinatesSlice';
import trendLibrarySlice from '../features/data-history/TrendLibrary/TrendLibrarySlice';
import trendItemSlice from '../features/data-history/TrendLibrary/TrendCoordinateSlice';
import TrendGroupLabelSlice from '../features/asset-analysis/TrendGroupLabel/TrendGroupLabelSlice';
import themeSlice from '../layouts/ThemeSlice';
import CustomViewDataSlice from '../features/data-history/TrendLibrary/DefaultTrendsSlice';
import TestWellDataSlice from '../components/slices/WellTestTableSlice';
import TestWellColumnsSlice from '../components/slices/ColumnSelectorSlice';
import WellTestIdSlice from '../components/slices/WellTestIdSlice';
import AssetTrendDataSlice from '../components/slices/AssetTrendDataSlice';
import WellTestChartDataSlice from '../components/slices/WellTestChartDataSlice';
import WellTestInstallationsSlice from '../components/slices/WellTestInstallationsSlice';
import ShutdownAndDropdownSlice from '../components/slices/ShutdownAndDropdownSlice';
import DailyAverageDataSlice from '../components/slices/DailyAverageDataSlice';
import PumpCheckerEventsSlice from '../components/slices/PumpCheckerEventsSlice';
import LineMarkerReset from '../components/slices/LineMarkerSlice';
import LatestAssetTrendDataSlice from '../components/slices/LatestAssetTrendDataSlice';
import wellNoteSlice from '../components/slices/WellNoteSlice';
import wellCommentsSlice from '../components/slices/WellCommentsSlice';
import AssetTrendDataByTagsSlice from '../components/slices/AssetTrendDataByTagsSlice';
import AnalysisChartDataSlice from '../components/slices/AnalysisChartSlice';
import AlarmHistorySlice from '../components/slices/AlarmHistorySlice';
import selectedRangesReducer from '../features/contextualizer/selectedRangesSlice';
import widgetAccessSlice from '../components/slices/WidgetAccessSlice';
import TasksHistorySlice from '../components/slices/TasksHistorySlice';
import DefaultWellTestSlice from '../components/slices/DefaultWellTestFetchSlice';
import AllyNavigationSlice from '../features/navigation/NavigationSlice';
import globalFilterReducer from '../features/setpoints-manager/GlobalFilterSlice';
import SearchHistorySlice from '../components/slices/AssetGroupSearchSlice';
import WellFiltersSlice from '../features/well-filters/WellFilterSlice';
import AssetLocationsSlice from '../components/slices/AssetLocationsSlice';
import cardViewerSlice from '../features/custom-views/CardViewerTab/CardViewerSlice';
import parameterGroupsReducer from '../features/setpoints-manager/parameterGroupsSlice';
import RecommendationsSlice from '../features/recommendations/RecommendationsSlice';
import installationHistorySlice from '../features/installs/InstallationHistorySlice';
import WellCompletionsSlice from '../features/well-completions/WellCompletionSlice';
import CreateCompletionsSlice from '../features/well-completions/create-Completions/CreateCompletionsSlice';
import wellSummaryDashboardReducer from '../features/well-summary/WellSummaryDashboardSlice';
import WellDiagnosisSlice from '../features/well-diagnosis/WellDiagnosisSlice';
import CreateInstallSlice from '../features/installs/create-install/CreateInstallSlice';
import espDashboardReducer from '../features/esp-dashboard/espDashboardSlice';
import glDashboardReducer from '../features/gl-dashboard/glDashboardSlice';
import realtimeInsightsReducer from '../features/well-summary/RealtimeInsightsSlice';
import runlifeDashboardReducer from '../features/runlife-dashboard/RunlifeDarshboardSlice';
import eventCounterReducer from '../features/navigation/EventCounterSlice';
import detailedDailySlice from '../features/downtime/DetailedDailySlice';
import downtimeDailyReducer from '../features/downtime/daily-summary/slice';
import wellControlReducer from '../features/custom-views/MultiWellControlConfirm/WellControlSlice';
import widgetLayoutSlice from '../well-chart/WidgetLayoutSlice';
import assetTimezoneSlice from '../features/asset/AssetTimezoneSlice';

export const store = configureStore({
  reducer: {
    assetData: assetSlice,
    rodliftwellstatus: rodPumpWellStatusReducer,
    uiButtons: uiButtonToolbarReducer,
    assetGroups: assetGroupReducer,
    notificationButtons: uiButtonToolbarReducer,
    notificationType: notificationsTypesSlice,
    rodLiftAnalysis: cardDateSlice,
    rodLiftAnalysisCardCoordinates: cardCoordinatesSlice,
    rodLiftAnalysisAnalysis: analysisSlice,
    notificationsList: notificationSlice,
    tableView: tableViewSlice,
    groupStatus: groupStatusSlice,
    groupStatusWidget: groupStatusWidgetSlice,
    espAnalysisWellTest: espWellTestSlice,
    espAnalysisResult: espAnalysisSlice,
    glAnalysisData: glAnalysisSlice,
    gLAnalysisSurveyDate: gLAnalysisSurveyDateSlice,
    glAnalysisWellTest: glAnalysisWellTestSlice,
    notificationFilter: notificationFilterReducer,
    viewOptions: viewOptionsReducer,
    AssetAnalysis: AssetAnalysisSlice,
    signInDefaultView: signInDefaultViewSlice,
    glAnalysisSurveyCurveCoordinates: glAnalysisSurveyCurveCoordinatesSlice,
    espAnalysisCardCoordinates: espCardCoordinatesSlice,
    glAnalysisCurveCoordinates: glAnalysisCurveCoordinatesSlice,
    trendLibrary: trendLibrarySlice,
    trendItem: trendItemSlice,
    trendGroupLabel: TrendGroupLabelSlice,
    theme: themeSlice,
    customViewDataSlice: CustomViewDataSlice,
    testWellDataSlice: TestWellDataSlice,
    testWellColumnsSlice: TestWellColumnsSlice,
    WellTestIdSlice: WellTestIdSlice,
    AssetTrendDataSlice: AssetTrendDataSlice,
    WellTestChartDataSlice: WellTestChartDataSlice,
    WellTestInstallationsSlice: WellTestInstallationsSlice,
    shutdownAndDropdownSlice: ShutdownAndDropdownSlice,
    DailyAverageDataSlice: DailyAverageDataSlice,
    PumpCheckerEventsSlice: PumpCheckerEventsSlice,
    LineMarkerReset: LineMarkerReset,
    LatestAssetTrendData: LatestAssetTrendDataSlice,
    WellNoteSlice: wellNoteSlice,
    WellCommentsSlice: wellCommentsSlice,
    AssetTrendDataByTagsSlice: AssetTrendDataByTagsSlice,
    AnalysisChartDataSlice: AnalysisChartDataSlice,
    AlarmHistorySlice: AlarmHistorySlice,
    selectedRanges: selectedRangesReducer,
    widgetAccessSlice: widgetAccessSlice,
    TasksHistorySlice: TasksHistorySlice,
    DefaultWellTest: DefaultWellTestSlice,
    AllyNavigationSlice: AllyNavigationSlice,
    globalFilter: globalFilterReducer,
    SearchHistorySlice: SearchHistorySlice,
    WellFiltersSlice: WellFiltersSlice,
    AssetLocationsSlice: AssetLocationsSlice,
    cardViewerSlice: cardViewerSlice,
    parameterGroups: parameterGroupsReducer,
    Recommendations: RecommendationsSlice,
    installationHistorySlice: installationHistorySlice,
    WellCompletions: WellCompletionsSlice,
    CreateCompletions: CreateCompletionsSlice,
    wellSummaryDashboard: wellSummaryDashboardReducer,
    WellDiagnosis: WellDiagnosisSlice,
    createInstalls: CreateInstallSlice,
    espDashboard: espDashboardReducer,
    glDashboard: glDashboardReducer,
    realtimeInsights: realtimeInsightsReducer,
    runlifeDashboard: runlifeDashboardReducer,
    eventCounter: eventCounterReducer,
    detailedDaily: detailedDailySlice,
    downtimeDaily: downtimeDailyReducer,
    wellControl: wellControlReducer,
    widgetLayout: widgetLayoutSlice,
    assetTimezone: assetTimezoneSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
